module.exports = __webpack_public_path__ + "static/media/imatrix.a1107457.svg";